import React from 'react';
import { betterTypeOf } from './betterTypeOf';

const _reactElementCSVFormatter = (element: React.ReactNode): string => {
  const type = betterTypeOf(element);

  if (type === 'null' || type === 'undefined') return '';
  if (type === 'string') return element as string;
  if (type === 'number') return element.toString();
  if (type === 'boolean') return element ? 'True' : 'False';
  if (type === 'array')
    return (element as React.ReactNode[])
      .map(_reactElementCSVFormatter)
      .filter((part) => !!part)
      .join(' ');
  if (
    type === 'object' &&
    Object.prototype.hasOwnProperty.call(element, 'props')
  )
    return _reactElementCSVFormatter(
      (element as React.ReactElement)?.props?.children
    );

  if (type === 'object') return JSON.stringify(element);
  return '';
};

export const reactElementCSVFormatter = (element: React.ReactNode): string => {
  const s = _reactElementCSVFormatter(element);
  if (s.includes(',')) return `"${s}"`;
  return s;
};
